const Home = () => {

    return(
        <section></section>
    );

};

export default Home;